// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/auth'
import { ensureGateCbOnAddressBar } from '@/utils/gateCb'
import { Toast, Dialog } from 'vant'
import store from '@/store'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home/index.vue'),
        meta: {
            title: '首页',
            requiresAuth: true
        }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/ForgotPassword/index.vue'),
        meta: {
            title: '忘记密码'
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/Profile/index.vue'),
        meta: {
            title: '个人中心',
            requiresAuth: true
        }
    },
    {
        path: '/app-download',
        name: 'AppDownload',
        component: () => import('@/views/AppDownloadPage/index.vue'),
        meta: {
            title: 'APP下载',
        }
    },
    {
        path: '/hailiao',
        name: 'Hailiao',
        component: () => import('@/views/Hailiao/index.vue'),
        meta: {
            title: '在线客服',
            requiresAuth: false,
        }
    },
    {
        path: '/mall',
        name: 'Mall',
        component: () => import('@/views/Mall/index.vue'),
        meta: {
            title: '产品',
        }
    },
    {
        path: '/orders',
        name: 'OrderList',
        component: () => import('@/views/Mall/OrderList/index.vue'),
        meta: {
            requiresAuth: true,
            title: '我的订单'
        }
    },
    {
        path: '/address',
        name: 'Address',
        component: () => import('@/views/AddressManagement/index.vue'),
        meta: {
            requiresAuth: true,
            title: '地址管理'
        }
    },
    {
        path: '/address/add',
        name: 'AddressAdd',
        component: () => import('@/views/AddressManagement/AddressEdit.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/address/edit/:id',
        name: 'AddressEdit',
        component: () => import('@/views/AddressManagement/AddressEdit.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/verification',
        name: 'Verification',
        component: () => import('@/views/Verification/index.vue'),
        meta: {
            title: '实名认证',
            requiresAuth: true
        }
    },
    {
        path: '/security',
        name: 'Security',
        component: () => import('@/views/Security/index.vue'),
        meta: {
            title: '安全中心',
            requiresAuth: true
        }
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('@/views/Help/index.vue'),
        meta: {
            title: '帮助中心',
            requiresAuth: true
        }
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About/index.vue'),
        meta: {
            title: '关于我们',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw',
        name: 'Withdraw',
        component: () => import('@/views/Withdraw/index.vue'),
        meta: {
            title: '提现',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-bind',
        name: 'WithdrawBind',
        component: () => import('@/views/WithdrawBind/index.vue'),
        meta: {
            title: '提现信息绑定',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-asset',
        name: 'WithdrawAsset',
        component: () => import('@/views/WithdrawAsset/index.vue'),
        meta: {
            title: '提现到资产余额',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-history',
        name: 'WithdrawHistory',
        component: () => import('@/views/WithdrawHistory/index.vue'),
        meta: {
            title: '提现明细',
            requiresAuth: true
        }
    },
    {
        path: '/withdraw-history/:id',
        name: 'WithdrawHistoryDetail',
        component: () => import('@/views/WithdrawHistory/Detail.vue'),
        meta: {
            title: '提现记录',
            requiresAuth: true
        }
    },
    {
        path: '/asset-history',
        name: 'AssetHistory',
        component: () => import('@/views/AssetHistory/index.vue'),
        meta: {
            title: '资产明细',
            requiresAuth: true
        }
    },
    {
        path: '/asset-history/:id',
        name: 'AssetHistoryDetail',
        component: () => import('@/views/AssetHistory/Detail.vue'),
        meta: {
            title: '资金回执单',
            requiresAuth: true
        }
    },
    {
        path: '/bind-bank-card',
        name: 'BindBankCard',
        component: () => import('@/views/BindBankCard/index.vue'),
        meta: {
            title: '绑定银行卡',
            requiresAuth: true
        }
    },
    {
        path: '/real-name',
        name: 'RealName',
        component: () => import('@/views/RealName/index.vue'),
        meta: {
            title: '实名认证',
            requiresAuth: true
        }
    },
    {
        path: '/team',
        name: 'Team',
        component: () => import('@/views/Team/index.vue'),
        meta: {
            title: '我的团队',
            requiresAuth: true
        }
    },
    {
        path: '/invite',
        name: 'Invite',
        component: () => import('@/views/Invite/index.vue'),
        meta: {
            title: '邀请好友',
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login/index.vue'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/Register/index.vue'),
        meta: {
            title: '注册'
        }
    },
    {
        path: '/download/guide',
        name: 'downloadGuide',
        component: () => import('@/views/DownloadGuidePage/index.vue'),
        meta: {
            title: '下载指引'
        }
    },
    {
        path: '/403',
        name: '403',
        component: () => import('@/views/error/403.vue'),
        meta: {
            title: '无权访问'
        }
    },
    {
        path: '/monthly-sign-in',
        name: 'MonthlySignIn',
        component: () => import('@/views/MonthlySignIn/index.vue'),
        meta: {
            title: '月度签到',
            requiresAuth: true
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/views/error/404.vue'),
        meta: {
            title: '页面未找到'
        }
    },
    {
        path: '/government',
        name: 'Government',
        component: () => import('@/views/Government/index.vue'),
        meta: {
            title: '政务中心',
            requiresAuth: true
        }
    },
    {
        path: '/government/list/:category',
        name: 'GovernmentList',
        component: () => import('@/views/Government/List.vue'),
        meta: {
            title: '政务内容',
            requiresAuth: true
        }
    },
    {
        path: '/government/construction-guide',
        name: 'GovernmentConstructionGuide',
        component: () => import('@/views/Government/ConstructionGuide.vue'),
        meta: {
            title: '建设指南',
            requiresAuth: true
        }
    },
    {
        path: '/government/content/:id',
        name: 'GovernmentDetail',
        component: () => import('@/views/Government/Detail.vue'),
        meta: {
            title: '内容详情',
            requiresAuth: true
        }
    },
    {
        path: '/pension',
        name: 'Pension',
        component: () => import('@/views/Pension/index.vue'),
        meta: {
            title: '全民养老中心',
            requiresAuth: true,
            requiresRealName: true
        }
    },
    {
        path: '/pension/apply',
        name: 'PensionApply',
        component: () => import('@/views/Pension/Apply.vue'),
        meta: {
            title: '填写认证信息',
            requiresAuth: true,
            requiresRealName: true
        }
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        // 始终滚动到顶部
        return { top: 0 }
    }
})

// 白名单：不需要登录就可以访问的路由
const whiteList = ['/login', '/register', '/forgot-password', '/403', '/404', '/app-download', '/download/guide']

router.beforeEach(async (to, from, next) => {
    const web_name = "全民养老";
    document.title = to.meta.title ? `${to.meta.title} - ${web_name}` : web_name

    const token = getToken()

    // 判断是否有token
    if (token) {
        if (to.path === '/login' || to.path === '/register') {
            // 已登录状态下访问登录页，重定向到首页
            next('/')
            return
        }

        // 判断是否已经获取了用户信息
        if (!store.state.user.userInfo) {
            try {
                await store.dispatch('user/getUserInfo')
            } catch (error) {
                await store.dispatch('user/logout')
                Toast.fail('登录状态已过期，请重新登录')
                next(`/login?redirect=${to.path}`)
                return
            }
        }

        // 全民养老中心办理需先实名
        if (to.matched.some((r) => r.meta.requiresRealName)) {
            let userInfo = store.state.user.userInfo
            if (!userInfo?.real_name) {
                try {
                    await store.dispatch('user/getUserInfo')
                    userInfo = store.state.user.userInfo
                } catch (e) {
                    // ignore, fall through to prompt
                }
            }

            if (!userInfo?.real_name) {
                try {
                    await Dialog.confirm({
                        title: '提示',
                        message: '办理全民养老需先完成实名认证，是否前往实名认证？',
                        confirmButtonText: '去实名',
                        cancelButtonText: '取消',
                        confirmButtonColor: '#e60012',
                    })
                    next({
                        path: '/real-name',
                        query: { redirect: to.fullPath },
                    })
                } catch (e) {
                    next(false)
                }
                return
            }
        }

        next()
    } else {
        // 没有token
        if (whiteList.includes(to.path) || to.path.startsWith('/download/') || !to.meta.requiresAuth) {
            // 白名单中的页面或不需要认证的页面，直接访问
            next()
        } else {
            // 其他需要登录的页面，重定向到登录页
            next(`/login?redirect=${to.path}`)
        }
    }
})

// 用 replaceState 补 cb，不改动 Vue 历史栈，避免二级页返回失效
router.afterEach((to) => {
    ensureGateCbOnAddressBar(to.path)
})

export default router